import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about scroll-fade-in" id="about">
      <div className="about__intro">
        <p className="about__kicker">About MythLabs</p>
        <h2>We build cosmic-grade product stacks.</h2>
        <p>
          MythLabs fuses product strategy, engineering, and motion design into one crew.
          We prototype fast, codify the magic, and leave teams with playbooks they can
          run without us.
        </p>
      </div>
    </section>
  );
}

export default About;



